export default "__VITE_ASSET__a7f81dcd__"